// extracted by mini-css-extract-plugin
export default {"tooltip":"ln-z","sharingV2":"mn-z","sharingIconsV2":"nn-z","links":"on-z","link":"pn-z","facebookV2":"qn-z","twitterV2":"rn-z","pinterestV2":"sn-z"};